<template>
  <form-section
    :title="$t('CampaignForm_Schedule_PersistContent_Title')"
    :description="$t('CampaignForm_Schedule_PersistContent_Description')"
    class="item-ct"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('persistContent')"
  >
    <radio-group v-model="model.persist_type" inline>
      <radio
        :label="0"
        border
        :title="$t('CampaignForm_Schedule_PersistContent_DoNotRemove')"
        :description="
          $t('CampaignForm_Schedule_PersistContent_DoNotRemove_Description')
        "
        data-qa="persist-do-not-remove-option-radio"
      />

      <radio-custom
        :label="1"
        :border="true"
        data-qa="persist-remove-on-option-radio"
      >
        <div v-if="model.persist_type === 1" class="radio-inner-ct">
          <div
            :class="{ title: true, 'title-active': model.persist_type === 1 }"
          >
            {{ $t('CampaignForm_Schedule_PersistContent_RemoveOn') }}
          </div>
          <div v-if="model.persist_type === 1" class="radio-input">
            <el-date-picker
              size="small"
              v-model="model.persist_until"
              type="datetime"
              format="MMMM d yyyy HH:mm"
              :picker-options="pickerOptions"
              value-format="timestamp"
              class="date-input"
            />
          </div>
        </div>
        <div class="description" v-else>
          <div class="title title-active">
            {{ $t('CampaignForm_Schedule_PersistContent_RemoveOn') }}
          </div>
          {{ $t('CampaignForm_Schedule_PersistContent_RemoveOn_Description') }}
        </div>
      </radio-custom>

      <radio-custom
        :label="2"
        :border="true"
        data-qa="persist-remove-after-option-radio"
      >
        <div v-if="model.persist_type === 2" class="radio-inner-ct">
          <div
            :class="{ title: true, 'title-active': model.persist_type === 2 }"
          >
            {{ $t('CampaignForm_Schedule_PersistContent_RemoveAfter') }}
          </div>
          <div v-if="model.persist_type === 2" class="radio-input">
            <el-input-number
              v-model="model.persist_for"
              size="small"
              controls-position="right"
              :min="1"
              :max="999"
              data-qa="remove-after-number-input"
            />
            <el-select
              v-model="model.persist_for_period"
              size="small"
              data-qa="remove-after-duration-dropdown"
            >
              <el-option
                v-for="(label, value) in options"
                :key="value"
                :value="value"
                :label="$t(label)"
              />
            </el-select>
          </div>
        </div>
        <div class="description" v-else>
          <div class="title title-active">
            {{ $t('CampaignForm_Schedule_PersistContent_RemoveAfter') }}
          </div>
          {{
            $t('CampaignForm_Schedule_PersistContent_RemoveAfter_Description')
          }}
        </div>
      </radio-custom>
    </radio-group>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RadioCustom from '@/modules/campaign-manage/components/locations/RadioCustom'
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
import moment from 'moment'

export default {
  name: 'PersistContentComponent',
  components: { FormSection, Radio, RadioGroup, RadioCustom },
  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      options: {
        seconds: 'CampaignForm_Schedule_PersistContent_Period_Seconds',
        minutes: 'CampaignForm_Schedule_PersistContent_Period_Minutes',
        hours: 'CampaignForm_Schedule_PersistContent_Period_Hours',
        days: 'CampaignForm_Schedule_PersistContent_Period_Days',
        weeks: 'CampaignForm_Schedule_PersistContent_Period_Weeks'
      },
      pickerOptions: {
        disabledDate: date => moment(date).isBefore(this.now, 'date')
      }
    }
  }
}
</script>

<style scoped>
.item-ct {
  margin-top: 20px;
}

>>> .el-input-number {
  width: 170px;
}

.radio-input {
  width: 225px;
  max-width: 300px;
  display: flex;
  align-items: center;
}

.radio-input > div:first-child {
  margin-right: 15px;
}

.radio-inner-ct {
  display: flex;
}

.title,
>>> .title {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #4b515f;
}

>>> .el-radio__label .title {
  font-size: 14px;
  color: #5c6374;
}

.title-active {
  margin-right: 20px;
  align-self: center;
}

.description {
  color: #7e8596;
  font-size: 12px;
}

.input-description {
  margin-right: 10px;
  color: #7e8596;
  font-size: 12px;
}

.date-input {
  width: 210px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/PersistContentComponent.vue